export default __webpack_public_path__ + "static/media/Chamber-Media-Logo-p-1080.59f4fd3f.png";